import { cookie } from '@playcastdotio/Cookie';
import { createPlayerPersistentId } from '@playcastdotio/CreateId';

/**
 * Gets or creates a persistent browser identity UUID for the current user/device.
 *
 * Stored in both a cookie (for cross-path sharing) and localStorage (for persistence).
 * Used as the `persistentId` field in analytics identity and as a correlation key
 * across host and player analytics events.
 */
export const getPersistentPlayerId = (): string => {
  const { get, set } = cookie();
  const id = get('playcast-player-id') || localStorage.getItem('playcast-player-id');
  if (id) return id;

  const searchParams = new URLSearchParams(window.location.search);
  const playerId = searchParams.get('id');
  if (playerId) {
    set('playcast-player-id', playerId);
    localStorage.setItem('playcast-player-id', playerId);
    return playerId;
  }

  const newId = createPlayerPersistentId();
  set('playcast-player-id', newId);
  localStorage.setItem('playcast-player-id', newId);
  return newId;
};
